{
  "name": "dragonfly",
  "version": "5.1.0+V28",
  "author": "galaveras@inteliqua.com",
  "homepage": "https://eliquacx.com/",
  "scripts": {
    "start": "ng serve --port 9000",
    "build:dev": "ng build --configuration development",
    "build:prod": "ng build --configuration production",
    "test": "ng test",
    "lint": "ng lint",
    "format": "prettier --config .prettierrc.json --write .",
    "format:check": "prettier --config .prettierrc.json --check .",
    "prepare": "git config core.hooksPath .githooks || exit 0",
    "sonar": "sonar-scanner"
  },
  "engines": {
    "node": ">=22.12.0",
    "npm": ">=10.0.0"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^20.3.23",
    "@angular/cdk": "^20.2.14",
    "@angular/common": "^20.3.23",
    "@angular/compiler": "^20.3.23",
    "@angular/core": "^20.3.23",
    "@angular/forms": "^20.3.23",
    "@angular/material": "^20.2.14",
    "@angular/platform-browser": "^20.3.23",
    "@angular/platform-browser-dynamic": "^20.3.23",
    "@angular/router": "^20.3.23",
    "@bluehalo/ngx-leaflet": "^20.0.0",
    "@danielmoncada/angular-datetime-picker": "^20.0.0",
    "@fortawesome/angular-fontawesome": "^3.0.0",
    "@fortawesome/fontawesome-svg-core": "^6.7.1",
    "@fortawesome/free-solid-svg-icons": "^6.7.1",
    "@ngrx/effects": "^20.1.0",
    "@ngrx/entity": "^20.1.0",
    "@ngrx/store": "^20.1.0",
    "@ngrx/store-devtools": "^20.1.0",
    "@types/uuid": "^9.0.0",
    "date-fns": "^2.29.3",
    "file-saver": "^2.0.5",
    "jsoneditor": "^10.2.0",
    "leaflet": "^1.9.4",
    "marked": "^16.4.0",
    "ngx-markdown": "^20.0.0",
    "rxjs": "~7.8.0",
    "tslib": "^2.8.1",
    "uuid": "^9.0.1",
    "zone.js": "^0.15.1"
  },
  "overrides": {
    "axios": "^1.8.4"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^20.3.27",
    "@angular-eslint/builder": "^20.0.0",
    "@angular-eslint/eslint-plugin": "^20.0.0",
    "@angular-eslint/eslint-plugin-template": "^20.0.0",
    "@angular-eslint/schematics": "^20.0.0",
    "@angular-eslint/template-parser": "^20.0.0",
    "@angular/cli": "~20.3.27",
    "@angular/compiler-cli": "^20.3.23",
    "@angular/localize": "^20.3.23",
    "@types/file-saver": "^2.0.7",
    "@types/jasmine": "^4.6.4",
    "@types/jsoneditor": "^9.9.5",
    "@types/leaflet": "^1.9.21",
    "eslint": "^8.57.1",
    "jasmine-core": "~4.5.0",
    "karma": "^6.4.4",
    "karma-chrome-launcher": "~3.1.0",
    "karma-coverage": "^2.2.1",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.0.0",
    "prettier": "3.9.4",
    "sonarqube-scanner": "^4.2.6",
    "typescript": "~5.8.3"
  }
}